import {useLocation, Link} from 'react-router-dom'

export const HeaderTabs: React.FC = () => {
  const location = useLocation()

  return (
    <div className='card mb-5'>
      <div className='card-body pt-1 pb-1'>
        <div className='d-flex overflow-auto h-55px'>
          <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap'>
            <li className='nav-item'>
              <Link
                className={
                  `nav-link text-active-primary me-6 ` +
                  (location.pathname === '/stock/initial-assignment' && 'active')
                }
                to='/stock/initial-assignment'
              >
                Initial Stock Assignment
              </Link>
            </li>
            <li className='nav-item'>
              <Link
                className={
                  `nav-link text-active-primary me-6 ` +
                  (location.pathname === '/stock/in-purchases' && 'active')
                }
                to='/stock/in-purchases'
              >
                Stock In
              </Link>
            </li>
            <li className='nav-item'>
              <Link
                className={
                  `nav-link text-active-primary me-6 ` +
                  (location.pathname === '/stock/out-sales' && 'active')
                }
                to='/stock/out-sales'
              >
                Stock Out
              </Link>
            </li>
            <li className='nav-item'>
              <Link
                className={
                  `nav-link text-active-primary me-6 ` +
                  (location.pathname === '/stock/transfer' && 'active')
                }
                to='/stock/transfer'
              >
                Stock Transfer
              </Link>
            </li>
            <li className='nav-item'>
              <Link
                className={
                  `nav-link text-active-primary me-6 ` +
                  (location.pathname === '/stock/adjustments' && 'active')
                }
                to='/stock/adjustments'
              >
                Stock Adjustments
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  )
}
